module.exports = __webpack_public_path__ + "static/img/i28.a27cd29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cpzy/i28.png
// module id = 2vpm
// module chunks = 3